const GET_COST_ANALYTICS_DATA = (state, costAnalyticsData) => {
  state.costAnalyticsData = costAnalyticsData;
};

const GET_DETAIL_COST_ANALYTICS_DATA = (state, detailCostAnalyticsData) => {
  state.detailCostAnalyticsData = detailCostAnalyticsData;
};

const SET_ORIGINAL_DETAIL_COST_ANALYTICS_DATA = (state, originalDetailCostAnalyticsData) => {
  state.originalDetailCostAnalyticsData = originalDetailCostAnalyticsData;
};

const SET_VISIBLE_COLUMN_FIELDS = (state, visibleColumnFields) => {
  state.visibleColumnFields = visibleColumnFields;
};

const SET_IS_CLOSE_QUICK_FILTER_DROPDOWN = (state, isCloseQuickFilterDropdown) => {
  state.isCloseQuickFilterDropdown = isCloseQuickFilterDropdown;
};

const GET_PORTION_DETAIL_COST_ANALYTICS_DATA = (state, portionDetailCostAnalyticsData) => {
  state.portionDetailCostAnalyticsData = portionDetailCostAnalyticsData;
};

const GET_PORTION_DETAIL_COST_ANALYTICS_COMPARE_DATA = (state, portionCompareData) => {
  state.portionDetailCostAnalyticsCompareData = portionCompareData;
};

const SET_VIEW_BY = (state, viewType) => {
  state.filterSettings.viewBy = viewType;
};

const SET_FILTER_SETTINGS = (state, filterSettings) => {
  state.filterSettings = filterSettings
}

const SET_FILTER_OPTIONS = (state, filterOptions) => {
  state.filterOptions = filterOptions;
};

const SET_USER_FILTERS = (state, userFilters) => {
  state.userFilters = userFilters;
};

const CLEAR_HORIZONTAL_STACKED_CHART_SINGLE_DATA = (state) => {
  state.portionDetailCostAnalyticsData = {}
};

const SET_INITIAL_LOAD = (state, value) => {
  state.isInitialLoad = value;
}

const SET_IS_MONTHLY = (state, isMonthly) => {
  state.isMonthly = isMonthly;
}

const SET_IS_OTHERS = (state, isMonthly) => {
  state.isOthers = isMonthly;
}

export default {
  GET_COST_ANALYTICS_DATA,
  GET_DETAIL_COST_ANALYTICS_DATA,
  SET_ORIGINAL_DETAIL_COST_ANALYTICS_DATA,
  GET_PORTION_DETAIL_COST_ANALYTICS_DATA,
  SET_VIEW_BY,
  SET_FILTER_SETTINGS,
  SET_FILTER_OPTIONS,
  SET_USER_FILTERS,
  GET_PORTION_DETAIL_COST_ANALYTICS_COMPARE_DATA,
  CLEAR_HORIZONTAL_STACKED_CHART_SINGLE_DATA,
  SET_VISIBLE_COLUMN_FIELDS,
  SET_IS_CLOSE_QUICK_FILTER_DROPDOWN,
  SET_INITIAL_LOAD,
  SET_IS_MONTHLY,
  SET_IS_OTHERS
};



// WEBPACK FOOTER //
// ./src/store/modules/cost-analytics/mutations.js